import React, { useEffect, useState } from "react";
import "rc-tooltip/assets/bootstrap_white.css";
import UTIL from "../../../../util";
import classes from "./PreAuth.module.css";
import strings from '../../../../globalization';
import FireboardUtils from "../../../../util/fireboard-util";
import API from "../../../../requests";

const leftBasicInfo = [
  {
    title: strings.server,
    key: 'server',
  },
  {
    title: `${strings.orderType_Table}:`,
    key: 'table',
  },
  {
    title: `${strings.placeholderPhone}: `,
    key: 'phoneNumber',
  },
];

const rightInfo = [
  {
    title: strings.gateway,
    key: 'gateway',
  },
  {
    title: strings.cardType,
    key: 'cardType',
  },
  {
    title: strings.cardNumber,
    key: 'cardNumber',
  },
  {
    title: strings.name,
    key: 'name',
  },
];

const leftInfo = [
  {
    title: `${strings.totalAmount}:`,
    key: 'totalAmount',
  },
  {
    title: `${strings.paidAmount}:`,
    key: 'paidAmount',
  },
  {
    title: `${strings.unpaidAmount}:`,
    key: 'unpaidAmount',
  },
];

const rightBasicInfo = [
  {
    title: strings.business_date,
    key: 'businessDate',
  },
  {
    title: strings.check_number,
    key: 'number',
  },
  {
    title: `${strings.openOrders}:`,
    key: 'open',
  },
];

const PreAuth = (props) => {
  const {
    preAuthItem = {},
    tipSubmit,
    dismissPopup,
    defaultPreAuthTipPercentage,
    supportsGratuityForPreAuth,
    currency = '$',
    iso2,
  } = props;
  const { selectedCheckDetails = {} } = preAuthItem || {};
  const unpaid = preAuthItem.unpaidAmount;
  const gratuityIntial = defaultPreAuthTipPercentage * 100;
  let calcGratuityIntial = (unpaid * +gratuityIntial) / 100;

  const [calcGratuity, setCalcGratuity] = useState(calcGratuityIntial);
  const [gratuity, setGratuity] = useState(gratuityIntial);
  const [phoneNumber, setPhoneNumber] = useState();

  useEffect(() => {
    const { tickets, unpaidAmount } = preAuthItem;
    if (Array.isArray(tickets) && tickets.length > 0) {
      tickets.forEach(ticket => {
        const { ticketStatusId, preAuth, MemberId } = ticket || {};
        if (ticketStatusId === 0 && preAuth && unpaidAmount > 0) {
          getMemberDetails(MemberId);
        }
      });
    }
  }, []);

  const getMemberDetails = memberId => {
    API.getMemberDetails({ memberId })
      .then(res => {
        setPhoneNumber(FireboardUtils.formattedPhoneNumber(res.data.phoneNumber, iso2));
        FireboardUtils.addNetworkLogs(res);
      })
      .catch(error => {
        FireboardUtils.addNetworkLogs(error.response);
        console.info('error calling member details', error.request);
      });
  };

  const getHeader = () => (
    <div className={classes.header}>
      <span onClick={dismissPopup} className={classes.backIcon} >  {`<Back`} </span>
      <span className={classes.odLabel}>onedine</span>
    </div>
  );

  const isGratuityEnabled = () => {
    return supportsGratuityForPreAuth || defaultPreAuthTipPercentage > 0;
  };

  const getDateTime = dt => {
    const date = new Date(dt);
    const day = date.getDay() < 10 ? `0${date.getDay()}` : date.getDay();
    const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1;
    return `${month}/${day}/${date.getFullYear()}`;
  };

  const renderValue = bi => {
    const ticket = selectedCheckDetails && selectedCheckDetails.tickets && selectedCheckDetails.tickets[0];
    switch (bi.key) {
      case 'cardType': {
        return <div className={classes.infoKeyValueStyle}>{UTIL.getCardName(ticket.cardType)}</div>;
      }
      case 'cardNumber': {
        return <div className={classes.infoKeyValueStyle}>{ticket.redactedCardNumber}</div>;
      }
      case 'name': {
        return <div className={classes.infoKeyValueStyle}>{ticket.cardHolderName}</div>;
      }
      case 'server': {
        if (selectedCheckDetails && selectedCheckDetails.employeeFirstName && selectedCheckDetails.employeeLastName) {
          return (
            <div className={classes.infoKeyValueStyle}>
              {`${selectedCheckDetails.employeeFirstName} ${selectedCheckDetails.employeeLastName}`}
            </div>
          );
        }
        return <div className={classes.infoKeyValueStyle}>- -</div>;
      }
      case 'phoneNumber': {
        return <div className={classes.infoKeyValueStyle}>{phoneNumber || '- -'}</div>;
      }
      case 'paidAmount':
      case 'unpaidAmount':
      case 'totalAmount': {
        return <div className={classes.infoKeyValueStyle}>{currency}{selectedCheckDetails[bi.key] || ''}</div>;
      }
      case 'businessDate': {
        return (
          <div className={classes.infoKeyValueStyle}>
            {getDateTime(selectedCheckDetails[bi.key]) || ''}
          </div>
        );
      }
      case 'table': {
        const station = selectedCheckDetails.tab
          ? selectedCheckDetails.name || '- -'
          : selectedCheckDetails.stationName || '- -';
        return <div style={classes.infoKeyValueStyle}>{`${station}`}</div>;
      }
      case 'open': {
        const openTime = FireboardUtils.getTimeInHrsMins(selectedCheckDetails.openDate);
        return <div style={classes.infoKeyValueStyle}>{`${openTime}`}</div>;
      }
      default: {
        return <div className={classes.infoKeyValueStyle}>{selectedCheckDetails[bi.key] || ''}</div>;
      }
    }
  };

  const renderInfoView = bi => (
    <div className={classes.infoViewStyle} key={`info_${bi.title}`}>
      <div className={classes.infoTextStyle}>{bi.title}</div>
      {renderValue(bi)}
    </div>
  );

  const gratuityOnChange = (event) => {
    const gratuityChange = +event.target.value;
    setGratuity(event.target.value);
    if (/^\d+(\.\d{1,2})?$/.test(gratuityChange) && gratuityChange <= defaultPreAuthTipPercentage * 100) {
      setCalcGratuity((unpaid * gratuityChange) / 100);
    }
  };

  return (
    <div className={classes.container}>
      {getHeader()}
      <div className={classes.infoContentStyle}>
        <div className={classes.rowContainer}>
          <div className={classes.row}>
            <div className={classes.leftSec}>{leftBasicInfo.map(bi => renderInfoView(bi))}</div>
            <div className={classes.basicInfo}>
              {rightBasicInfo.map(bi => renderInfoView(bi))}
            </div>
          </div>
          <div className={classes.tipInfoRow}>
            <div className={classes.tipInfoRowColumnLeft}>{leftInfo.map(bi => renderInfoView(bi))}</div>
            <div className={classes.tipInfoRowColumnRight}>{rightInfo.map(bi => renderInfoView(bi))}</div>
          </div>
          <div className={[classes.toggleViewStyle, classes.alignCenter].join(' ')}>
            <div className={[classes.toggleTextStyle, classes.tipAdjust].join(' ')}>{`${strings.gratuity}   (max ${gratuityIntial}%)`}</div>

            <input
              value={gratuity}
              disabled={!isGratuityEnabled()}
              className={[+gratuity > (defaultPreAuthTipPercentage * 100) ? classes.tipAdjustStyleRed : classes.tipAdjustStyle]}
              type='number' onChange={(event) => gratuityOnChange(event)} />
              <span className={classes.percent}>%</span>
            <div className={classes.preAuthAmountText}>({`${currency} ${calcGratuity.toFixed(2) || calcGratuityIntial.toFixed(2)}`})</div>
          </div>
          <div className={[classes.toggleViewStyle, classes.alignCenter].join(' ')}>
            <div className={[classes.toggleTextStyle, classes.tipAdjust].join(' ')}>
              {`${strings.dueAmount}:`}
            </div>
            <div className={classes.dueAmountStyle}>
              <div className={classes.preAuthAmountText}>
                {`${currency} ${(unpaid + calcGratuity).toFixed(2)}`}
              </div>
            </div>
          </div>
        </div>
        <button onClick={() => {
          let gratuityPercentage = gratuity;
          const allowedValue = defaultPreAuthTipPercentage * 100;
          if (gratuityPercentage > allowedValue)
            gratuityPercentage = allowedValue;
          tipSubmit(gratuityPercentage);
        }
        } className={classes.loginBtn}>
          <span className={classes.loginText}>{strings.tipSubmit}</span>
        </button>
      </div>
    </div>

  );
};

export default PreAuth;
